import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role, redirectTo = "/login" }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#07111D] flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-[#18BFFF] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to={redirectTo} state={{ from: location }} replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin-portal/dashboard" : "/client/dashboard"} replace />;
  }
  return children;
}
